// @flow
import React, { Component } from "react";
import withStyles from "elevate-ui/withStyles";
import classNames from "classnames";
import KeyboardArrowDown from "elevate-ui-icons/KeyboardArrowDown";
import KeyboardArrowUp from "elevate-ui-icons/KeyboardArrowUp";
import Input from "elevate-ui/Input";
import { FastField } from "formik";
import enhanceWithClickOutside from "react-click-outside";

import Dropdown from "./Dropdown";

type $Props = {
  className?: string,
  classes: Object,
  values: Object,
  mlsApiVersion: number,
};

type $State = {
  isOpen: boolean,
};

class Price extends Component<$Props, $State> {
  minFastFieldId = "minPrice";
  minFastFieldName = "minPrice";
  maxFastFieldId = "maxPrice";
  maxFastFieldName = "maxPrice";

  constructor(props) {
    super(props);

    if (this.props.mlsApiVersion === 2) {
      this.minFastFieldId = "min_listingPrice";
      this.minFastFieldName = "amin_listingPrice";
      this.maxFastFieldId = "max_listingPrice";
      this.maxFastFieldName = "amax_listingPrice";
    }

    this.state = {
      isOpen: false,
    };
  }

  toggleDropdown = () => {
    this.setState((state) => ({ isOpen: !state.isOpen }));
  };

  handleClickOutside() {
    if (this.state.isOpen) {
      this.setState({ isOpen: false });
    }
  }

  renderDisplayText = (values: Object) => {
    const currency = new Intl.NumberFormat("en", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
    });
    if (this.props.mlsApiVersion === 2) {
      if (values.amin_listingPrice && values.amax_listingPrice) {
        return `${currency.format(
          values.amin_listingPrice
        )} - ${currency.format(values.amax_listingPrice)}`;
      } else if (values.amaxListingPricee) {
        return `0 - ${currency.format(values.amax_listingPrice)}`;
      } else if (values.aminListingPrice) {
        return `${currency.format(values.amin_listingPrice)}+`;
      } else {
        return "Any Price";
      }
    } else {
      if (values.minPrice && values.maxPrice) {
        return `${currency.format(values.minPrice)} - ${currency.format(
          values.maxPrice
        )}`;
      } else if (values.maxPrice) {
        return `0 - ${currency.format(values.maxPrice)}`;
      } else if (values.minPrice) {
        return `${currency.format(values.minPrice)}+`;
      } else {
        return "Any Price";
      }
    }
  };

  render() {
    const { className, classes, values } = this.props;
    const { isOpen } = this.state;

    return (
      <div className={classes.container}>
        <div
          className={classNames(classes.root, className)}
          onClick={this.toggleDropdown}
        >
          {this.renderDisplayText(values)}{" "}
          {this.state.isOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
        </div>
        <Dropdown isOpen={isOpen}>
          <FastField
            id={this.minFastFieldId}
            name={this.minFastFieldName}
            label="Min Price"
            component={Input}
            type="number"
          />
          <FastField
            id={this.maxFastFieldId}
            name={this.maxFastFieldName}
            label="Max Price"
            component={Input}
            type="number"
          />
        </Dropdown>
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    display: "flex",
    flexRow: "row nowrap",
    justifyContent: "space-between",
    alignItems: "center",
    position: "relative",
    width: 200,
    height: 48,
    margin: "8px auto 16px",
    padding: "8px 12px",
    color: theme.typography.bodyColor,
    fontFamily: "inherit",
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "20px",
    backgroundColor: "#fff",
    border: theme.borders["default"],
    borderRadius: theme.globalBorderRadius,
    cursor: "default",
  },
  container: {
    position: "relative",
  },
});

export default withStyles(styles, { name: "Price" })(
  enhanceWithClickOutside(Price)
);
